import { render, staticRenderFns } from "./OccurrenceTable.vue?vue&type=template&id=29ba8bab&"
import script from "./OccurrenceTable.vue?vue&type=script&lang=js&"
export * from "./OccurrenceTable.vue?vue&type=script&lang=js&"
import style0 from "./OccurrenceTable.vue?vue&type=style&index=0&id=29ba8bab&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports